import { render, staticRenderFns } from "./pet-reply-refer-form.vue?vue&type=template&id=472647c0&"
import script from "./pet-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./pet-reply-refer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports